import { usePatternUniverses } from "@/contexts/PatternUniverse";
import { useQuickStrategyContext } from "@/contexts/QuickStrategyContext";
import { Plus } from "lucide-react";
import { useCallback, useEffect } from "react";
import NoScannerFound from "./components/scannerSectionComponents/NoScannerFound";
import PreBuiltScanners from "./components/scannerSectionComponents/PreBuiltScanners";
import UserScanners from "./components/scannerSectionComponents/UserScanners";
import { useRecoilState } from "recoil";
import { guideModalAtom } from "@/Atoms/modal/DialogueAtoms";

const ScannerSection = () => {
  const { scannerStrategies, refetchScannerStrategies, userId } =
    usePatternUniverses();
  const { changeScannerType, openQuickStrategy, setQuickStrategyModalToggle } =
    useQuickStrategyContext();
  const [showGuideModal, setShowGuideModal] = useRecoilState(guideModalAtom);

  const handleQuickStrategyCreate = useCallback(() => {
    setQuickStrategyModalToggle(true);
    changeScannerType(true);
  }, []);

  useEffect(() => {
    refetchScannerStrategies(false, userId);
  }, [refetchScannerStrategies]);

  return (
    <>
      <div className="w-full rounded-lg border bg-card shadow-sm flex mx-auto my-2 flex-col gap-2 p-6">
        <div className="w-full flex flex-row justify-between">
          <div className="flex flex-col gap-2">
            <p className="font-semibold tracking-tight text-xl flex gap-2 items-center text-nowrap">
              Your Scanners
            </p>
            <p className="text-sm">
              <span className="text-muted-foreground">
                Not sure how to create a scanner ?{" "}
              </span>
              <span
                className="cursor-pointer"
                onClick={() =>
                  setShowGuideModal({
                    isOpen: true,
                    link: "https://www.youtube.com/embed/Ghc9KOvGqX0?si=iHsDynDvfOUozNWm",
                  })
                }
              >
                Click here
              </span>
            </p>
          </div>
          {scannerStrategies.length > 0 && (
            <Plus
              className="cursor-pointer"
              onClick={handleQuickStrategyCreate}
              size={40}
              strokeWidth={1}
            />
          )}
        </div>
        {scannerStrategies.length > 0 ? <UserScanners /> : <NoScannerFound />}
        <p className="font-semibold tracking-tight text-xl flex gap-2 items-center text-nowrap">
          Pre-built Scanners
        </p>
        <p className="text-muted-foreground text-xs">
          These pre-built Strategy Scanners help traders quickly identify
          high-potential opportunities without constant monitoring. Once
          deployed, they continuously track your chosen assets, analysing market
          conditions in real time. By highlighting key setups and trends, they
          provide a clear starting point for your next strategy—saving time and
          improving decision-making
        </p>
        <PreBuiltScanners />
      </div>
    </>
  );
};

export default ScannerSection;
